// src/pages/Blogs.js
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const Blogs = () => {

  const blogs = [
    {
      id: "1",
      title: "Top Web Development Trends in 2026",
      desc: "Latest technologies shaping modern websites and digital experiences.",
      img: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
      date: "March 2026",
      category: "Development",
    },
    {
      id: "2",
      title: "Why SEO is Important for Business Growth",
      desc: "Improve your rankings, visibility and organic traffic with smart SEO strategies.",
      img: "https://images.pexels.com/photos/270348/pexels-photo-270348.jpeg",
      date: "February 2026",
      category: "Marketing",
    },
    {
      id: "3",
      title: "Mobile App vs Website – What Should You Choose?",
      desc: "Understand which platform fits your business goals and audience better.",
      img: "https://images.pexels.com/photos/607812/pexels-photo-607812.jpeg",
      date: "January 2026",
      category: "Strategy",
    },
    {
      id: "4",
      title: "Digital Marketing Strategies That Work",
      desc: "Boost your brand online with proven and effective marketing techniques.",
      img: "https://images.pexels.com/photos/905163/pexels-photo-905163.jpeg",
      date: "December 2025",
      category: "Marketing",
    },
  ];

  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) setVisible(true);
    }, { threshold: 0.2 });

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bg-[#f9fafb]">

      {/* HERO */}
      <div className="relative h-[60vh] flex items-center justify-center text-center">

        <img
          src="https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg"
          alt="blog"
          className="absolute w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative text-white max-w-2xl px-6">
          <h1 className="text-4xl md:text-5xl font-bold">
            Our Insights & Ideas
          </h1>
          <p className="mt-4 text-gray-200">
            Learn, explore and grow with our expert knowledge.
          </p>
        </div>
      </div>

      {/* BLOG LIST */}
      <div ref={ref} className="max-w-6xl mx-auto px-6 py-20 space-y-20">

        {blogs.map((item, i) => (
          <div
            key={item.id}
            className={`flex flex-col md:flex-row gap-10 items-center group transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
            }`}
            style={{ transitionDelay: `${i * 120}ms` }}
          >

            {/* IMAGE */}
            <div className="w-full md:w-[45%] overflow-hidden rounded-2xl">
              <img
                src={item.img}
                alt=""
                className="w-full h-[260px] object-cover group-hover:scale-105 transition duration-500"
              />
            </div>

            {/* CONTENT */}
            <div className="w-full md:w-[55%]">

              <p className="text-sm text-gray-400 tracking-wide">
                {item.date} • {item.category}
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-3 leading-snug group-hover:text-red-600 transition">
                {item.title}
              </h2>

              <p className="text-gray-600 mt-4 leading-relaxed">
                {item.desc}
              </p>

              <Link
                to={`/blog/${item.id}`}
                className="inline-block mt-5 text-red-600 font-semibold relative"
              >
                Read Article →
                <span className="block h-[2px] w-0 bg-red-600 transition-all group-hover:w-full"></span>
              </Link>

            </div>

          </div>
        ))}

      </div>

      {/* CTA */}
      <div className="bg-white py-20 text-center border-t">

        <h2 className="text-3xl font-bold text-gray-900">
          Want More Insights?
        </h2>

        <p className="text-gray-500 mt-3">
          Stay connected and keep learning with us.
        </p>

        <Link to="/contact">
          <button className="mt-6 px-8 py-3 bg-red-600 text-white rounded-full hover:bg-red-700 transition">
            Contact Us
          </button>
        </Link>

      </div>

    </section>
  );
};

export default Blogs;